import setPendingCA from "./setPendingCA";
import setBlankCA from "./setBlankCA";
import store from "../store/index";
//-------------------------------------
// load specific combatant extra image
//-------------------------------------
export default function loadSpecificCombatantExtraImage(idx, action_deletion = false) {
  // console.log("-----------------------------------");
  // console.log("IN loadSpecificCombatantExtraImages");
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let combatants = this_store.arena.arena_combatants;
  let maxCA = this_store.config.max_ca;
  let caExtra = maxCA + 1;
  let caExtra_field = "ca_slug" + caExtra;
  // console.log("caExtra_field = " + caExtra_field);
  //-----------------------------------------------------
  // where no existing ca-extra OR is an action deletion
  //-----------------------------------------------------
  // console.log(
  //   "idx = " +
  //     idx +
  //     " combatants[k][caExtra_field] = " +
  //     combatants[idx][caExtra_field] + " deletion = " + action_deletion
  // );

  if (combatants[idx][caExtra_field] == "" || action_deletion) {
    //---------------
    // set slot parm
    //---------------
    let slot_parm = {
      id: combatants[idx].id,
      ca_num: caExtra,
    };
    //------------------------------
    // if extra - set pending image
    //------------------------------
    if (combatants[idx].extra) {
      setPendingCA(slot_parm);
      //--------------------------------
      // if NOT extra - set blank image
      //--------------------------------
    } else {
      setBlankCA(slot_parm);
    }
  }
}
